export const width = 404;
export const height = 384;
export default __webpack_public_path__ + "static/social-tree-rafiki.37dca99a.svg";